import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSidebar from './HseSidebar.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSidebar;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-Sidebar",class:( _obj = {
    'hse-Sidebar_open': _vm.isOpen || _vm.isStatic
  }, _obj[("hse-Sidebar_size_" + _vm.size)] = _vm.size, _obj[("hse-Sidebar_variant_" + _vm.variant)] = _vm.variant, _obj['hse-Sidebar_hasTitle'] =  _vm.needTitle, _obj['hse-Sidebar_withHeader'] =  _vm.withHeader, _obj )},[(_vm.needTitle || _vm.needToggle)?_c('div',{staticClass:"hse-Sidebar__header",class:_vm.classes.header},[(_vm.needToggle)?_c('div',{staticClass:"hse-Sidebar__toggleContainer",class:_vm.classes.toggleContainer},[_c('HseIconButton',{staticClass:"hse-Sidebar__toggleButton",class:_vm.classes.toggleButton,attrs:{"icon":_vm.toggleButtonIcon,"variant":"pagination","classes":_vm.iconButtonClasses},on:{"click":_vm.handleToggle}}),_vm._v(" "),_c('div',{staticClass:"hse-Sidebar__toggleText",class:_vm.classes.toggleText,on:{"click":_vm.handleToggle}},[_vm._t("toggle-text",[_vm._v("\n          "+_vm._s(_vm.toggleText)+"\n        ")])],2)],1):_vm._e(),_vm._v(" "),(_vm.needTitle)?_c('div',{staticClass:"hse-Sidebar__title",class:_vm.classes.title},[_vm._t("title",[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],2):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hse-Sidebar__content",class:_vm.classes.content},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
